import { render, staticRenderFns } from "./UploadPhotoIdLink.vue?vue&type=template&id=3552f2c2"
import script from "./UploadPhotoIdLink.vue?vue&type=script&lang=js"
export * from "./UploadPhotoIdLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports